import React, { useEffect, useState } from 'react';
import { FaChurch, FaCalendarAlt, FaUsers, FaMapMarkerAlt, FaChartLine } from 'react-icons/fa';
import { MdTrendingUp } from "react-icons/md";
import DashboardCard from '../../components/DashboardCard';
import { toast } from 'react-toastify';
import Header from '../../components/Header';
import { useAuth } from '../../context/Auth';



const Dashboard = () => {
  const {requestWithAuth} = useAuth();
  const [dashboardData, setDashboardData] = useState({});
  const [gettingData, setGettingData] = useState(false);

  const getDashboardData = async () => {
    try {
      setGettingData(true);
      const response = await requestWithAuth(`/superadmin/dashboard/`, "GET");
      setDashboardData(response);
    } catch (error) {
      toast.error("Failed to get data")
    }finally{
      setGettingData(false);
    }
  }

  useEffect(()=>{
    getDashboardData();
  },[])

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-blue-50/30 to-indigo-50/20 p-6">
      <div className="max-w-7xl mx-auto">
        <Header title="Superadmin Dashboard" />
        
        {/* Main Stats Cards */}
        <div className="grid lg:grid-cols-3 gap-6 mb-8">
          <DashboardCard
            title="Registered Churches" 
            subtitle="overall" 
            value={dashboardData?.registered_churches} 
            icon={FaChurch}
            trend="up"
            trendValue="+12%"
            color="blue"
          />
          <DashboardCard 
            title="Registered Churches" 
            subtitle="this month" 
            value={dashboardData?.registered_churches_this_month}
            icon={FaCalendarAlt}
            trend="up"
            trendValue="+8%"
            color="green"
          />
          <DashboardCard 
            title="Registered Churches" 
            subtitle="this year" 
            value={dashboardData?.registered_churches_this_year} 
            icon={MdTrendingUp}
            trend="up"
            trendValue="+25%"
            color="purple"
          />
        </div>

        {/* Quick Stats */}
        {/* <QuickStats /> */}

        {/* Bottom Section */}
        {/* <div className="grid lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2">
            <div className="bg-white rounded-2xl shadow-lg p-6 h-64 flex items-center justify-center">
              <div className="text-center">
                <FaChartLine className="text-6xl text-gray-300 mx-auto mb-4" />
                <p className="text-gray-500">Analytics Chart Placeholder</p>
                <p className="text-sm text-gray-400 mt-2">Church growth and engagement metrics</p>
              </div>
            </div>
          </div>
          <div>
            <RecentActivity />
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default Dashboard;